/* eslint-disable import/first */
import $ from "jquery";

window.$ = $;

import "@/shared/luxon_setting"; // タイムゾーン設定
import "@/user/pv_tracking"; // PV計測
import "@/user/cv_tracking"; // CVボタンクリックの計測
import "@/shared/navi"; // サイトナビの表示
import "@/shared/opt-in"; // cookieアラート表示
import "@/shared/timer_popup";
